var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerSenha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver-senha",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.923,
    height: 11.911,
    viewBox: "0 0 18.923 11.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_86",
    "data-name": "Grupo 86",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_160",
    "data-name": "Caminho 160",
    d: "M2.2,98.461a10.133,10.133,0,0,0,7.26,2.931,10.179,10.179,0,0,0,7.26-2.931,10.592,10.592,0,0,0,2.142-2.953.638.638,0,0,0,0-.533A9.053,9.053,0,0,0,16.776,92.2a10.578,10.578,0,0,0-7.382-2.72,10.345,10.345,0,0,0-7.315,2.731A8.581,8.581,0,0,0,.047,95a.629.629,0,0,0,.011.511A10.324,10.324,0,0,0,2.2,98.461Zm7.16-7.6A3.241,3.241,0,1,1,6.119,94.1,3.245,3.245,0,0,1,9.36,90.857ZM5.6,91.5a4.535,4.535,0,0,0-.81,2.6,4.573,4.573,0,1,0,8.314-2.62,8.438,8.438,0,0,1,4.385,3.774,10.053,10.053,0,0,1-1.754,2.309,8.7,8.7,0,0,1-6.283,2.52,8.752,8.752,0,0,1-6.283-2.531A10.091,10.091,0,0,1,1.4,95.231,8.135,8.135,0,0,1,5.6,91.5Z",
    transform: "translate(0.002 -89.481)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerSenha);
export default __webpack_public_path__ + "static/media/ver-senha.b5dc103a4bbad1e28aaf00c40a6f44d3.svg";
export { ForwardRef as ReactComponent };